import { getRequest, postRequest, putRequest } from './http.service';
import { URL_APPS_LIST, URL_FILE_TYPES } from './url.service';

export const URL_APP_BY_ID = (id: string) => `/apps/${id}`;

export const fetchApps = () => getRequest(URL_APPS_LIST);

export const updateAppSetting = (id: string, appSetting: Record<string, boolean>) =>
  putRequest(URL_APP_BY_ID(id), { appSetting });

export const saveFileTypes = (types: string[], orgId: string) =>
  postRequest(URL_FILE_TYPES, { types, orgId });
